export default {
  news: {
    loading: false,
    list: [],
    all: []
  },
  detail: {
    loading: false,
    data: null
  }
}
